import { defineSlotRecipe } from "@pandacss/dev";

export const aromaToggleButtons = defineSlotRecipe({
  slots: ["wrapper", "container", "item"],
  className: "aroma-toggle-buttons",
  jsx: ["ToggleButtons"],
  base: {
    container: {
      display: "flex",
      gap: "gap.1",
      flexWrap: "wrap",
      flexDirection: "row",
      '&[data-orientation="vertical"]': {
        flexDirection: "column",
      },
    },
    wrapper: {
      flexDirection: "column",
    },
    item: {
      boxSizing: "border-box",
      width: "fit-content",
      paddingY: "padding.1",
      paddingX: "padding.3",
      display: "flex",
      gap: "gap.2",
      placeContent: "center",
      placeItems: "center",
      textStyle: "title.s",
      color: "content.neutral.base.subtle",
      textDecoration: "none",
      backgroundColor: "background.neutral.base.subtlest",
      borderWidth: "m",
      borderStyle: "solid",
      borderColor: "border.neutral.bold",
      borderRadius: "s",
      cursor: {
        base: "pointer",
        _disabled: "default",
      },
      _hover: {
        backgroundColor: "background.neutral.base.subtlest-hover",
        borderColor: "border.neutral.bold-hover",
      },
      _focusVisible: {
        shadow: "effect.focus-ring.brand",
        outline: "none",
        borderColor: "border.brand-bold",
        _withinWhiteLabelTheme: {
          borderColor: "border.brand.brand-brand",
        },
      },
      _disabled: {
        backgroundColor: "background.neutral.disable.subtle",
        borderColor: "background.neutral.disable.subtle",
        color: "content.neutral.base.disable",
      },
      '&[data-state="on"]': {
        backgroundColor: "background.brand.subtle",
        borderColor: "border.brand-bold",
        color: "border.brand-bold",
        _hover: {
          backgroundColor: "background.brand.subtle-hover",
          borderColor: "border.brand-bold",
          color: "border.brand-bold",
        },
      },
      _aromaticonChildren: {
        fontSize: "20px",
      },
    },
  },
  variants: {
    size: {
      small: {
        item: { height: "m", minWidth: "m", py: "padding.1", px: "padding.3" },
      },
      medium: {
        item: {
          height: "xl",
          minWidth: "xl",
          borderRadius: "l",
          py: "padding.2",
          px: "padding.3",
        },
      },
    },
    iconOnly: { true: {}, false: {} },
    hierarchy: {
      primary: {
        item: {
          _disabled: {
            backgroundColor: "background.neutral.disable.subtle",
            borderColor: "background.neutral.disable.subtle",
            color: "content.neutral.base.disable",
            '&[data-state="on"]': {
              backgroundColor: "background.brand.subtle",
              borderColor: "background.brand.subtle",
              color: "content.brand.subtlest",
            },
          },
        },
      },
      warning: {
        item: {
          borderColor: "border.functional.warning",
          '&[data-state="on"]': {
            backgroundColor: "background.functional.warning.subtle",
            borderColor: "border.functional.warning",
            color: "content.functional.warning",
          },
          _disabled: {
            backgroundColor: "background.neutral.disable.subtle",
            borderColor: "background.neutral.disable.subtle",
            color: "content.neutral.base.disable",
            _hover: {
              backgroundColor: "background.neutral.base.subtlest-hover",
            },
          },
          _hover: {
            backgroundColor: "background.functional.warning.subtle-hover",
            borderColor: "border.functional.warning-hover",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.warning",
          },
        },
      },
      error: {
        item: {
          borderColor: "border.functional.error",
          '&[data-state="on"]': {
            backgroundColor: "background.functional.error.subtle",
            borderColor: "border.functional.error",
            color: "content.functional.error",
          },
          _disabled: {
            backgroundColor: "background.neutral.disable.subtle",
            borderColor: "background.neutral.disable.subtle",
            color: "content.neutral.base.disable",
            _hover: {
              backgroundColor: "background.neutral.base.subtlest-hover",
            },
          },
          _hover: {
            backgroundColor: "background.functional.error.subtle-hover",
            borderColor: "border.functional.error-hover",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.error",
          },
        },
      },
    },
  },
  defaultVariants: {
    size: "small",
    iconOnly: false,
    hierarchy: "primary",
  },
});
